// extracted by mini-css-extract-plugin
export default {"feedback_section":"FeedbackSection_feedback_section__U0C+I","feedback_card":"FeedbackSection_feedback_card__EFv9c","mySwiper":"FeedbackSection_mySwiper__HQC1k"};